<template>
  <div class="row">
    <div class="col-12 col-lg-6 c h">
        <div class="card">
            <div class="card-header">
                <h5>
                    توزيع على الحافلات
                </h5>
            </div>
            <div class="card-footer">
                <div class="form-group">
                  <label for="">الحملة</label>
                  <select class="form-control" v-model="hamla" @change="getBusses()">
                    <option value="1">الباقة 2</option>
                    <option value="2">الباقة 4</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="">توزيع على باص محدد</label>
                  <select class="form-control" v-model="custom_bus">
                    <option value="all">توزيع على الكل</option>
                    <option v-for="bus in busses" :key="bus._id" :value="bus._id">
                        {{ bus.title }}
                    </option>
                  </select>
                </div>
                <div class="g border bg-light-warning">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" name="" id="" v-model="groupByOrderId" value="ture">
                        توزيع برقم الحجز / رقم المجاورة
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" name="" id="" v-model="groupByNationalId" value="ture">
                        توزيع بالجنسية
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" name="" id="" v-model="prioritizeWomen" value="ture">
                        أولوية الإناث
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" name="" id="" v-model="separateGenders" value="ture">
                        فصل الجنسين
                      </label>
                    </div>
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" name="" id="" v-model="considerStartLocation" value="ture">
                        توزيع بنقطة الانطلاق
                      </label>
                    </div>
                    <hr>
                    
                    <draggable
                        :list="list"
                        :disabled="!enabled"
                        class="list-group"
                        ghost-class="ghost"
                        :move="checkMove"
                        @start="dragging = true"
                        @end="dragging = false"
                    >
                        <div
                        class="list-group-item"
                        v-for="element in list"
                        :key="element.name"
                        >
                        {{ element.ar }}
                        </div>
                    </draggable>

                </div>
                <br>
                <div class="col-12 text-center" v-if="loading">
                    <div class="spinner-grow text-primary spinner-grow-sm" style="position: relative; top: -5px" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    جاري التوزيع...
                    <br><span id="status"></span>
                    <br>
                    <span class="text-danger">* لا تقم ببدء عملية جديدة الا بعد انتهاء هذه العملية، حتى ولو غادرت الصفحة فهي تعمل في الخلفية.</span>
                </div>
                <div class="col-12 text-center" v-if="!loading">
                    <button class="btn btn-primary" @click="arrangeNow()">
                        توزيع الان
                    </button>&nbsp;
                    <button class="btn btn-secondary" @click="arrangeNowOLD()">
                        توزيع بالآلية القديمة
                    </button>&nbsp;
                    <button class="btn btn-info" @click="arrangeAdmins()">
                        توزيع المشرفين
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 g">
        <div class="card">
            <div class="card-header">
                توزيع الحجاج في 
                الحافلات
            </div>
            <div class="card-body">
                <app-collapse>
                    <app-collapse-item
                    v-for="bus in busses"
                    :key="bus._id"
                    :title="bus.title + `, ${bus.mix ? 'عوائل' : 'رجال'} (${bus.users.length} حاج من ${bus.limit}) [${bus.admins.length} من ${bus.admin_limit} مشرف]`"
                    >
                    <div class="g">
                        <button class="btn btn-sm btn-primary" style="border-radius: 0px" @click="print(bus._id, bus.title, `
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        السائق
                                    </td>
                                    <td>
                                        جوال
                                        السائق
                                    </td>
                                    <td>
                                        المساعد
                                    </td>
                                    <td>
                                        جوال
                                        المساعد
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        ${bus.driver_name}
                                    </td>
                                    <td>
                                        ${bus.driver_phone}
                                    </td>
                                    <td>
                                        ${bus.helper_name}
                                    </td>
                                    <td>
                                        ${bus.helper_phone}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        الدليل
                                    </td>
                                    <td>
                                        جوال
                                        الدليل
                                    </td>
                                    <td>
                                        المشرف
                                    </td>
                                    <td>
                                        جوال
                                        المشرف
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        ${bus.guide_name}
                                    </td>
                                    <td>
                                        ${bus.guide_phone}
                                    </td>
                                    <td>
                                        ${bus.admin_name}
                                    </td>
                                    <td>
                                        ${bus.admin_phone}
                                    </td>
                                </tr>
                            </tbody>
                            `, false,bus.plate_number)">
                            <i class="fa fa-print"></i>
                            طباعة كشف الحجاج
                        </button>
                        <button class="btn btn-sm btn-success" style="border-radius: 0px" @click="excel(bus.users, bus.title, false)">
                            <i class="fa fa-download"></i>
                        </button>
                        &nbsp;<button class="btn btn-sm btn-primary" style="border-radius: 0px" @click="print(bus._id, bus.title, ``, true, bus.plate_number)">
                            <i class="fa fa-print"></i>
                            طباعة كشف المشرفين
                        </button>
                        <button class="btn btn-sm btn-success" style="border-radius: 0px" @click="excel(bus.admins, bus.title, true)">
                            <i class="fa fa-download"></i>
                        </button>
                        &nbsp;
                        <button class="btn btn-sm btn-outline-danger" style="border-radius: 0px" @click="emptyBus(bus)">
                            <i class="fa fa-times"></i>
                            تفريغ الحافلة
                        </button>
                        &nbsp;
                        <button class="btn btn-sm btn-outline-danger" style="border-radius: 0px" @click="emptyBus2(bus)">
                            <i class="fa fa-times"></i>
                            تفريغ الحافلة من المرشفين
                        </button>
                        &nbsp;
                        <button class="btn btn-sm btn-outline-primary" style="border-radius: 0px" @click="printkashf(bus.users)">
                            <i class="fa fa-print"></i>
                            كشف تسليم بطاقات النسك
                        </button>
                    </div>
                    <div class="col-12 table-responsive" :class="'print_' + bus._id">
                        <table class="table table-hover table-sm table-bordered">
                            <thead>
                                <th>
                                    اجمالي الحجاج
                                </th>
                                <th>
                                    الرجال
                                </th>
                                <th>
                                    النساء
                                </th>
                                <th>
                                    الاماكن الفارغة للحجاج
                                </th>
                                <th>
                                    المشرفين
                                </th>
                                <th>
                                    اجمالي الركاب
                                </th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ bus.users.length }}
                                    </td>
                                    <td>
                                        {{ bus.mens }}
                                    </td>
                                    <td>
                                        {{ bus.womans }}
                                    </td>
                                    <td>
                                        {{ bus.limit - bus.users.length }}
                                    </td>
                                    <td>
                                        {{ bus.admins.length }}
                                    </td>
                                    <td>
                                        {{ bus.admins.length + bus.users.length }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-sm table-bordered table-hover">
                            <thead>
                                <th class="dnone">
                                    م
                                </th>
                                <th>
                                    الاسم
                                </th>
                                <th>
                                    رقم الهوية
                                </th>
                                <th>
                                    الهاتف
                                </th>
                                <th>
                                    رقم الحجز
                                </th>
                                <th>
                                    نقطة الانطلاق
                                </th>
                                <th>
                                    الجنسية
                                </th>
                            </thead>
                            <tbody>
                                <tr v-for="(u, i) in bus.users" :key="u._id">
                                    <td class="dnone">
                                        {{ i+1 }}
                                    </td>
                                    <td>
                                        {{ u.name }}
                                    </td>
                                    <td>
                                        {{ u.number }}
                                    </td>
                                    <td>
                                        {{ u.phone }}
                                    </td>
                                    <td>
                                        {{ u.order_id }}
                                    </td>
                                    <td>
                                        {{ u.start_location }}
                                    </td>
                                    <td>
                                        {{ u.national }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12 table-responsive" :class="'print2_' + bus._id">
                        <table class="table table-sm table-bordered table-hover">
                            <thead>
                                <th class="dnone">
                                    م
                                </th>
                                <th>
                                    الاسم
                                </th>
                                <th>
                                    اسم المستخدم
                                </th>
                                <th>
                                    الهاتف
                                </th>
                            </thead>
                            <tbody>
                                <tr v-for="(u, i) in bus.admins" :key="u._id">
                                    <td class="dnone">
                                        {{ i+1 }}
                                    </td>
                                    <td>
                                        {{ u.name }}
                                    </td>
                                    <td>
                                        {{ u.username }}
                                    </td>
                                    <td>
                                        {{ u.phone }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </app-collapse-item>
                </app-collapse>
                


            </div>
        </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Ripple from "vue-ripple-directive";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
var XLSX = require("xlsx");
export default {
    directives: {
        Ripple,
    },
    components: {
        draggable,
        AppCollapse,
        AppCollapseItem
    },
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            busses: [],
            enabled: true,
            list: [
                { name: "groupByOrderId", id: 0, ar: "التوزيع برقم الحجز / رقم المجاورة" },
                { name: "groupByNationalId", id: 1, ar: "التوزيع بالجنسية" },
                { name: "prioritizeWomen", id: 2, ar: "الأولوية للنساء" },
                { name: "separateGenders", id: 3, ar: "فصل الجنسين" },
                { name: "startLocation", id: 4, ar: "التوزيع بنقطة الانطلاق" }
            ],
            dragging: false,
            custom_bus: "all",
            'groupByOrderId': false,
            groupByNationalId: false,
            'prioritizeWomen': true,
            'separateGenders': true,
            considerStartLocation: false,
            'startLocation': false,
            hamla: "1",
            loading: false,
            instructions: "",
            sort: "default"
        }
    },
    created(){
        if(!checkPer('arrange')){
            this.$router.push('/pers')
            return;
        }
        this.getBusses()
    },
    methods: {
      excel(users, title, ll){
          const wb = XLSX.utils.book_new(), g = this;
          const Heading = [
              ll ? [
                  "الاسم",
                  "اسم المستخدم",
                  "الهاتف",
                  "الحافلة"
              ] : [
                  "الاسم",
                  "رقم الهوية",
                  "الهاتف",
                  "رقم الحجز",
                  "نقطة الانطلاق",
                  "الجنسية",
                  "الحافلة"
              ]
          ];
          var xx = [];
          function xxx(x){
            return x;
          }
          users.forEach(function(a, i){
              var arr = [];
              if(ll){
                arr.push(xxx(a.name))
                arr.push(xxx(a.username))
                arr.push(xxx(a.phone))
                arr.push(xxx(title))
              }else{
                arr.push(xxx(a.name))
                arr.push(xxx(a.number))
                arr.push(xxx(a.phone))
                arr.push(xxx(a.order_id))
                arr.push(xxx(a.start_location))
                arr.push(xxx(a.national))
                arr.push(xxx(title))
              }
              xx.push(arr)
          })
          
          // creating sheet and adding data from 2nd row of column A.
          // leaving first row to add Heading
          const ws = XLSX.utils.json_to_sheet(xx, { origin: 'A2', skipHeader: true });
              
          // adding heading to the first row of the created sheet.
          // sheet already have contents from above statement.
          XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
              
          // appending sheet with a name
          XLSX.utils.book_append_sheet(wb, ws, 'Records');
              
          const fileContent = XLSX.writeFile(wb, (ll ? 'مشرفين ' : 'حجاج ') + title + ".xlsx");
      },
        emptyBus(bus){
            var g = this;
            if(confirm("متأكد من تفريغ الحافلة؟")){
                $.post(api + '/admin/busses/empty', {
                    jwt: g.user.jwt,
                    id: bus._id
                }).then(function(r){
                    g.getBusses()
                })
            }
        },
        printkashf(users){
            var g = this;
            var win = window.open()
            var html = '';
            users.forEach(function(a){
                html = html + `
                <tr>
                    <td>${a.name}</td>
                    <td style='text-align: center'>${a.number}</td>
                    <td style='text-align: center'>${a.order_id}</td>
                    <td style='width: 150px'></td>
                </tr>
                `
            })
            win.document.write(`
            <html dir='rtl'>
                <head>
                    <style>
                        table, td, th {
                            border: 1px solid;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                    </style>
                </head>
                <body>
                    <h4>كشف تسليم بطاقات نسك</h4>
                    <table class='table table-hover table-sm table-bordered'>
                        <thead>
                            <th>اسم الحاج</th>
                            <th>رقم الهوية</th>
                            <th>رقم الحجز</th>
                            <th>التوقيع</th>
                        </thead>
                        <tbody>
                            ${html}
                        </tbody>
                    </table>
                </body>
            </html>
            `)
            win.document.close()
            win.print()
        },
        emptyBus2(bus){
            var g = this;
            if(confirm("متأكد من تفريغ الحافلة من المشرفين؟")){
                $.post(api + '/admin/busses/empty2', {
                    jwt: g.user.jwt,
                    id: bus._id
                }).then(function(r){
                    g.getBusses()
                })
            }
        },
        arrangeNow(){
            var g = this;
            if(confirm("متأكد من اعادة التوزيع؟\nسوف يتم الغاء اي تعديلات يدوية سابقة.")){
                g.loading = true;
                $.post(api + '/admin/busses/arrange', {
                    jwt: g.user.jwt,
                    custom_bus: g.custom_bus,
                    "hamla": g.hamla,
                    priorityOrder: g.list.map(function(x){
                        return x.name
                    }),
                    "groupByOrderId": g.groupByOrderId,
                    "groupByNationalId": g.groupByNationalId,
                    "prioritizeWomen": g.prioritizeWomen,
                    "separateGenders": g.separateGenders,
                    "considerStartLocation": g.considerStartLocation

                }).then(function(r){
                    g.loading = false;
                    g.getBusses();
                })
            }
        },
        arrangeNowOLD(){
            var g = this;
            if(confirm("متأكد من اعادة التوزيع؟\nسوف يتم الغاء اي تعديلات يدوية سابقة.")){
                g.loading = true;
                $.post(api + '/admin/busses/arrange-old', {
                    jwt: g.user.jwt,
                    custom_bus: g.custom_bus,
                    "hamla": g.hamla,
                    priorityOrder: g.list.map(function(x){
                        return x.name
                    }),
                    "groupByOrderId": g.groupByOrderId,
                    "groupByNationalId": g.groupByNationalId,
                    "prioritizeWomen": g.prioritizeWomen,
                    "separateGenders": g.separateGenders,
                    "considerStartLocation": g.considerStartLocation

                }).then(function(r){
                    g.loading = false;
                    g.getBusses();
                })
            }
        },
        arrangeAdmins(){
            var g = this;
            if(confirm("متأكد من اعادة التوزيع؟\nسوف يتم الغاء اي تعديلات يدوية سابقة.")){
                g.loading = true;
                $.post(api + '/admin/busses/arrange-admins', {
                    jwt: g.user.jwt
                }).then(function(r){
                    g.loading = false;
                    g.getBusses();
                })
            }
        },
        checkMove: function(e) {
        },
        getBusses(){
            var g = this;
            $.post(api + '/admin/busses/list-with-users', {
                jwt: g.user.jwt,
                hamla: g.hamla
            }).then(function(r){
                g.busses = r.response;
            })
        },
        print(id, title, footer, r=false, p){
            var divToPrint = $(".print_" + id);
            if(r){
                var divToPrint = $(".print2_" + id);
            }
            var newWin= window.open("");
            newWin.document.write(`
            <style>
            table, td, th {
                border: 1px solid;
            }
            table {
                width: 100%;
                border-collapse: collapse;
            }
            html,body{
                direction: rtl
            }
            tr:nth-of-type(20n){
                page-break-after: always;
            }
            .x{
                position: relative;
                top: 100px
            }
            td:nth-child(2){
                text-align: right !important
            }
            th,td{
                padding-right: 3px;
                padding-left: 3px;
                text-align: center
            }
        .h5{
            position: absolute;
            top: -50px;
            right: 10px
        }
            .banner{
                width: 100%;
                position: fixed;
                top: 0px
            }
            .footer{
                width: 100%;
                position: fixed;
                bottom: 0px
            }
            tr:nth-child(even) {
                background-color: #f2f2f2;
            }
            @media print and (orientation: portrait) {
                .banner2{
                    display: none
                }
                .footer2{
                    display: none
                }
            }
            @media print and (orientation: landscape) {

            tr:nth-of-type(14n){
                page-break-after: always;
            }
                .banner{
                    display:none
                }
                .footer{
                    display: none
                }
                .banner2{
                    width: 100%;
                    position: fixed;
                    top: 0px
                }
                .footer2{
                    width: 100%;
                    position: fixed;
                    bottom: 0px
                }
            }
            .kitm{
            position: fixed;
            width: 100px;
            bottom: 70px;
            left: 10px;
            }
            </style>
            `)
            newWin.document.write(`
                <img class='banner' src='images/print-banner.png'>
                <img class='banner2' src='images/land-banner.png'>
                <div class='x'>
            <h4 class='h5'>كشف ${r ? 'المشرفين' : 'الحجاج'} للحافلة ${title}</h4>
            <table class='tablesz' style='margin: 0px'><thead><th>رقم الحافلة</th><th>${p}</th></thead></table>
            <h5 class='footerx'>${footer?.replaceAll('undefined', '')}</h5>
            ${divToPrint.html()}
            </div>
                <img class='footer' src='images/print-footer.png'>
                <img class='footer2' src='images/land-footer.png'>
                <img class='kitm' src='images/kitm.png'>
            `);
            newWin.document.close()
            setTimeout(() => {
                newWin.print();
            }, 1000);
        }
    }
}
</script>